module.exports = __webpack_public_path__ + "img/OSM-mapnik.0a8f144e.jpg";